<template>
	<div class="row mx-1">
		<!-- Column -->
		<e-select
			class="col-3 p-0"
			v-model="internalColumn"
			:options="availableColumns"
			:searchable="true"
			:allow-empty="false"
			:show-labels="true"
			track-by="key"
			label="label"
		/>
		<!-- Operator -->
		<e-select
			class="col-3 p-0"
			v-model="internalOperator"
			:options="availableOperators"
			:searchable="true"
			:sortable="false"
			:allow-empty="false"
			:show-labels="true"
			track-by="key"
			label="label"
		/>
		<!-- Input -->
		<e-select
            v-if="hasSearchValues"
			class="col-5 p-0"
            track-by="code"
            label="label"
            :options="searchValues"
            :searchable="true"
            :allow-empty="false"
            :show-labels="true"
            :search="true"
            v-model="internalValueObject"
            :placeholder="$t('global.rechercher')"
            @input="updateInternalValue"
        >
            <template slot="option" slot-scope="{ option }"><span v-html="cleanHTML(option.label)"></span></template>
            <template slot="singleLabel" slot-scope="{ option }"><span v-html="cleanHTML(option.label)"></span></template>
            <template slot="noOptions">{{ $t('global.list_empty') }}</template>
        </e-select>
		<b-form-input
			v-else
			class="col-5"
			ref="searchfield"
			v-model="internalValue"
			type="text"
			:placeholder="getTrad('global.recherchez_tableau')"
			debounce="500"
		/>
		<!-- Bouton vider le champs -->
		<b-button
			class="col-1 p-0"
			:disabled="!internalValue"
			@click="internalValue = ''"
		>
			<font-awesome-icon :icon="['fal', 'trash-alt']"/>
		</b-button>
	</div>
</template>

<script type="text/javascript">
	import TableSearchMixin from '@/mixins/TableSearch.js'
    import xss from 'xss'

	export default {
		name: 'TableSearchInput',
		mixins: [TableSearchMixin],
		props: {
			searchColumn: String,
			searchOperator: String,
			searchValue: String,
			columns: Array,
			typeSearch: Object
		},
		data: () => ({
			availableOperators: [],
			allowedOperators: [
				'isEqualTo',
				'isNotEqualTo',
				'isLowerThan',
				'isLowerOrEqualThan',
				'isGreaterThan',
				'isGreaterOrEqualThan',
				'mustContain',
				'mustNotContain',
				'beginWith',
				'doesntBeginWith',
				'endWith',
				'doesntEndWith',
				'isEmpty',
				'isNotEmpty',
				'isTrue',
				'isFalse'
			],
			searchValues: [],
			internalValueObject: null
		}),
		computed: {
			internalColumn: {
				get() {
					return this.availableColumns.find(col => (col.key === this.searchColumn))
				},
				set(val) {
					this.displayValues(val.key)
					this.$emit('update:searchColumn', val.key)
				}
			},
			internalOperator: {
				get() {
					return this.availableOperators.find(op => (op.key === this.searchOperator))
				},
				set(val) {
					this.$emit('update:searchOperator', val.key)
				}
			},
			internalValue: {
				get() {
					return this.searchValue
				},
				set(val) {
					this.updateInternalValueObject(val)
					this.$emit('update:searchValue', val)
				}
			},
			availableColumns() {
				return [{
					key: 'stringified',
					label: this.$t('table.general.search_stringified')
				}]
				.concat(this.columns)
			},
	        hasSearchValues() {
	            if(!this.typeSearch) return false
	            return Object.prototype.hasOwnProperty.call(this.typeSearch, this.internalColumn.key)
	        }
		},
		created() {
			const operators = this.getConfig('action_filter')

			this.availableOperators = operators
			.filter(op => {
				return this.allowedOperators.includes(op.action)
			})
			.map(op => {
				return {
					key: op.action,
					label: this.$t(`filtres.${op.label}`)
				}
			})
		},
		methods: {
			focus() {
				this.$refs.searchfield.$el.focus()
			},
			async displayValues(key) {
				this.searchValues = []
	            if(Object.prototype.hasOwnProperty.call(this.typeSearch, key)) {
	                this.searchValues = await this[this.typeSearch[key]]()
	                this.internalValueObject = null
	                this.updateInternalValue(null)
	            }
			},
	        cleanHTML(input) {
	            return xss(input)
	        },
	        updateInternalValue(val) {
	        	this.internalValue = val.code
	        },
	        updateInternalValueObject(val) {
	        	if(this.searchValues.length > 0) {
	        		this.internalValueObject = this.searchValues.find(v => v.code == val)
	        	}
	        }
		}
	}
</script>
